import { useEffect, useRef } from "react";
import ReactGA from "react-ga4";

export function useGoogleAnalytics(config) {
   const initialized = useRef(false);

   useEffect(() => {
      // Only initialize once
      if (initialized.current) return;

      function getTrackingID() {
         const params = new URLSearchParams(window.location.search);
         const gaIdFromQuery = params.get("ga_id");
         const gaIdFromConfig = config?.ga_id;

         // Query string takes precedence over config file
         const gaId = gaIdFromQuery || gaIdFromConfig;

         if(gaId){
            //console.log(`Got Google Analytics measurement ID: ${gaId}`)
         }
         else {
            console.log(`Google Analytics measurement ID not set`)
         }
         return gaId;
      }

      function initGoogleAnalytics(trackingID) {
         ReactGA.initialize(trackingID, {
            debug: true,
         });
         ReactGA.send("pageview");

         ReactGA.event({
            category: "Viewer Loaded",
            action: `Viewer Loaded`,
            label: window.location.href,
         });
      }

      const trackingID = getTrackingID();
      if (trackingID) {
         initGoogleAnalytics(trackingID);
         initialized.current = true;
      }
   }, [config]);
}
